import { StyleSheet } from 'react-native';
import { widthPercentageToDP as wp, heightPercentageToDP as hp } from 'react-native-responsive-screen';

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#FFFFFF',
  },
  scrollItemsContainer: {
    flexDirection: 'column',
    backgroundColor: '#FFFFFF',
  },
  header: {
    flexDirection: 'row',
    marginBottom: 50,
  },
  headerSmall: {
    display: 'flex',
    flexDirection: 'row',
    padding: 3,
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 4,
  },
  goBackContainerLarge: {
    flex: 0.1,
    alignSelf: 'center',
  },
  goBackContainerSmall: {
    alignSelf: 'center',
    flex: 0.3,
  },
  upperTextContainerLarge: {
    flexDirection: 'column',
    alignSelf: 'flex-end',
    marginTop: 45,
    flex: 0.25,
  },
  textTitleLargeCommerce: {
    color: '#807F7F',
  },
  textTitleLargeOrders: {
    flex: 0.2,
    color: '#000000',
    flexDirection: 'row',
    alignSelf: 'center',
    justifyContent: 'flex-start',
    fontSize: 22,
    fontWeight: '500',
    lineHeight: 20,
    textAlign: 'left',
  },
  registerOrderButtonContainerLarge: {
    width: '50%',
    marginTop: 25,
    flexDirection: 'row',
    alignSelf: 'center',
    justifyContent: 'center',
  },
  registerOrderButtonContainerSmall: {
    width: '80%',
    marginVertical: 15,
    flexDirection: 'row',
    alignSelf: 'center',
    justifyContent: 'center',
  },
  textLarge: {
    flex: 0.2,
    marginLeft: '0.5%',
    color: '#fff',
    alignSelf: 'center',
    fontSize: 16,
    fontWeight: '700',
  },
  textSmall: {
    flex: 0.55,
    marginLeft: '3%',
    alignSelf: 'center',
    justifyContent: 'center',
    color: '#001639',
    fontSize: 18,
    fontWeight: '700',
    lineHeight: 20,
  },
  btnContainer: {
    flex: 0.6,
    alignSelf: 'center',
    justifyContent: 'center',
  },
  orderBtnContainerLarge: {
    width: '60%',
    alignSelf: 'center',
    justifyContent: 'center',
    marginTop: '1%',
  },
  orderBtnContainerSmall: {
    width: '80%',
    alignSelf: 'center',
    justifyContent: 'center',
    marginTop: '1%',
  },
  btnTitleOrders: {
    color: '#001C47',
    fontSize: 16,
    fontWeight: '500',
    lineHeight: 20,
    textAlign: 'center',
    paddingVertical: 6,
    paddingHorizontal: 6,
  },
  orderBtnLarge: {
    backgroundColor: '#F5F5F5',
    borderRadius: 10,
    alignSelf: 'center',
    width: '100%',
  },
  orderBtnSmall: {
    backgroundColor: '#F5F5F5',
    borderRadius: 10,
    alignSelf: 'center',
    width: '100%',
  },
  iconLarge: {
    flex: 0.2,
    alignSelf: 'center',
  },
  iconSmall: {
    alignSelf: 'center',
  },
  button: {
    backgroundColor: '#f3f3f3',
    borderRadius: 12,
    marginTop: 20,
  },
  scannerButton: {
    backgroundColor: '#007AFF',
    padding: 15,
    borderRadius: 50,
    alignItems: 'center',
    justifyContent: 'center',
    width: 60,
    height: 60,
    marginTop: 5,
    marginLeft: 10,
  },
  buttonRechargeTitle: {
    color: '#FFF',
    fontWeight: 'bold',
    fontSize: 14,
    lineHeight: 17,
  },
  totalContainer: {
    height: 44,
    borderRadius: 12,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginRight: '17.1%',
    marginLeft: '2%',
    alignItems: 'center',
    paddingHorizontal: '13%',
    backgroundColor: 'white',
  },
  totalContainerLarge: {
    flex: 0.7,
    height: hp('19%'),
    width: wp('15%'),
    borderRadius: 10,
    flexDirection: 'row',
    alignSelf: 'center',
    marginLeft: '4%',
  },
  totalContainerSmall: {
    height: hp('10%'),
    width: '90%',
    borderRadius: 10,
    flexDirection: 'row',
    justifyContent: 'center',
    alignSelf: 'center',
  },
  totalTextContainerAdjustmentsLarge: {
    marginTop: 20,
    marginLeft: 35,
  },
  totalTextContainerAdjustmentsSmall: {
    justifyContent: 'center',
    alignSelf: 'center',
  },
  totalTextTitleLarge: {
    marginLeft: 15,
    fontSize: 14,
    fontWeight: '700',
    lineHeight: 20,
    textAlign: 'left',
    marginBottom: 5,
  },
  totalTextTitleSmall: {
    marginTop: 10,
    fontSize: 14,
    fontWeight: '700',
    textAlign: 'center',
  },
  totalTextBalanceLarge: {
    marginTop: 15,
    fontSize: 36,
    fontWeight: '700',
    lineHeight: 24,
    textAlign: 'left',
    marginBottom: 100,
  },
  totalTextBalanceSmail: {
    fontSize: 20,
    fontWeight: '700',
    lineHeight: 24,
    textAlign: 'center',
    marginBottom: 10,
  },
  cardsContainerLarge: {
    flex: 1,
    marginHorizontal: 30,
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  cardsContainerSmall: {
    marginHorizontal: 30,
    marginTop: 10,
    flexDirection: 'row',
    justifyContent: 'space-evenly',
  },
  cardColumn: {
    flex: 1,
    marginHorizontal: 30,
  },
  cardHeaderLarge: {
    paddingVertical: 40,
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 16,
  },
  buttonRecharge: {
    height: hp('10%'),
    borderRadius: 10,
    marginTop: 20,
    backgroundColor: '#F5F5F5',
    padding: 8,
    marginBottom: 6,
  },
  orderStatusTitleLarge: {
    color: '#001639',
    fontWeight: '500',
    fontSize: 18,
    lineHeight: 20,
    textAlign: 'center',
  },
  orderStatusTitleSmall: {
    color: '#001639',
    fontSize: 12,
    fontWeight: '500',
    lineHeight: 20,
    textAlign: 'center',
  },
  orderStatusNumberLarge: {
    color: '#001639',
    fontSize: 36,
    fontWeight: '700',
    lineHeight: 24,
    textAlign: 'center',
    marginVertical: 20,
  },
  orderStatusNumberSmall: {
    color: '#001639',
    fontSize: 20,
    fontWeight: '700',
    lineHeight: 24,
    textAlign: 'center',
    marginVertical: 15,
  },
  orderStatusContainerLarge: {
    paddingVertical: 20,
    width: wp('12%'),
    alignSelf: 'center',
    backgroundColor: '#F5F5F5',
    borderRadius: 10,
  },
  orderStatusContainerSmall: {
    paddingVertical: 10,
    alignSelf: 'center',
    width: 100,
    backgroundColor: '#F5F5F5',
    borderRadius: 10,
  },
  topRowFiltersOnOrdersListLarge: {
    flex: 1,
    flexDirection: 'row',
    alignSelf: 'flex-start',
    alignItems: 'flex-start',
    width: '70%',
    justifyContent: 'space-between',
    height: hp('50%'),
    paddingVertical: 15,
    paddingLeft: 65,
    borderRadius: 5,
    marginTop: 30,
  },
  topRowFiltersOnOrdersListSmall: {
    flex: 1,
    width: 300,
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    paddingVertical: 6,
    paddingRight: 8,
    paddingLeft: 8,
    marginHorizontal: 30,
  },
  topRowForDescriptionOnListOrders: {
    flex: 1,
    flexDirection: 'row',
    alignSelf: 'center',
    alignItems: 'center',
    width: '90%',
    justifyContent: 'flex-start',
    height: hp('10%'),
    paddingVertical: 15,
    borderRadius: 5,
    marginTop: 20,
    zIndex: 0,
  },
  topRowOrderItemOnOrdersListLarge: {
    flex: 0.1,
    borderWidth: 1,
    borderColor: '#001C47',
    paddingVertical: 10,
    alignSelf: 'center',
    width: wp('5%'),
    borderRadius: 10,
    marginHorizontal: 5,
  },
  topRowOrderItemOnOrdersListSmall: {
    flex: 1,
    borderWidth: 1,
    borderColor: '#001C47',
    paddingVertical: 10,
    alignSelf: 'center',
    width: wp('22%'),
    borderRadius: 10,
    marginHorizontal: 5,
  },
  topRowItemOnOrdersListLarge: {
    flex: 0.2,
    borderWidth: 1,
    borderColor: '#001C47',
    paddingVertical: 10,
    alignSelf: 'flex-start',
    width: wp('5%'),
    borderRadius: 10,
    marginHorizontal: 50,
  },
  topRowText: {
    fontSize: 14,
    fontWeight: '400',
    lineHeight: 20,
    textAlign: 'center',
    color: '#001C47',
  },
  topRowTextForDescription: {
    fontSize: 14,
    fontWeight: '400',
    lineHeight: 20,
    textAlign: 'center',
    color: '#FFFFFF',
  },
  topRowTextNotOrderItem: {
    fontSize: 14,
    fontWeight: '400',
    lineHeight: 20,
    textAlign: 'left',
    marginLeft: 10,
    color: '#001C47',
  },
  paginationContainer: {
    width: '100%',
    alignItems: 'center',
  },
  paginationButtons: {
    width: '600px',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginVertical: 16,
  },

  paginationButtonsSmall: {
    width: '80%',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginVertical: 16,
  },
});
